<template>
  <div
    id="eu"
    class="app-container content-container"
  >
    <div>
      <h1 style="text-align:center">
        INFORMACJE O KATEGORII
      </h1>
      <p style="font-size:2vh;line-height: 1.5;margin-top: 20px;">
        Projekt jest finansowany w ramach programu „Protecting EU Values and Fundamental Rights
        through Public Participation and Civil Society Assistance in Central Europe – PROTEUS”
        realizowanego przez TF we współpracy z programem Engaging Central Europe (ECE) of The
        German Marshall Fund of the United States. Program PROTEUS jest współfinansowany przez
        Europejską Agencję Wykonawczą ds. Edukacji i Kultury (EACEA) w ramach europejskiego
        programu „Obywatele, równość, prawa i wartości” (CERV).
      </p>
      <p style="font-size:2vh;line-height: 1.5;">
        Przedstawione poglądy i opinie są wyłącznie poglądami autora (autorów) i nie muszą
        odzwierciedlać poglądów Unii Europejskiej ani Europejskiej Agencji Wykonawczej ds.
        Edukacji i Kultury (EACEA). Unia Europejska ani organ przyznający dotację nie
        ponoszą za nie odpowiedzialności.
      </p>
    </div>
    <div class="buttons-row">
      <router-link
        tag="button"
        type="button"
        name="button"
        class="opaque-blue"
        to="/share-results"
      >
        Dalej
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SummaryEU',
};
</script>

<style scoped>
#eu {
  color: var(--color-blue);
  background: #EBF1F4;
}

#category-selection h1 {
  font-size: 120%;
  margin-bottom:1.5em;
}

div.jumbotron {
  text-align: center;
}
div.jumbotron img {
  width: 85%;
  padding: 0 auto 0 auto;
}

select {
  font-family: 'Montserrat';
  background: white;
  border: none;
  font-weight: 900;
  font-size: 175%;
  color: var(--color-blue);
}

label img {
  height: 1.8em;
  width: auto;
  max-width: 80%;
}

label .icon {
  margin-bottom: 0.6em;
  display: flex;
  align-items: center;
  justify-content: center
}

label .icon + div {
  line-height: 1.1em;
  font-size: 0.85em;
  min-height: 2.2em;
}

label {
  text-align: center;
  background: var(--color-lblue);
  border-radius:0.5em;
  padding:1em 0.95em 0.65em 0.95em;
  width: 100%;
  margin-bottom: 0.70em;
  position: relative;
  transition-duration: 0.3s;
}

label:before {
  height: 1.25em;
  width:1.25em;
  position: absolute;
  top:0.75em;
  left:0.75em;
  box-sizing: border-box;
  border-radius: 50%;
  content:'';
  border: 0.125em solid var(--color-border-blue);
  transition-duration: 0.2s;
}

label:after {
  height:0.75em;
  width:0.75em;
  position: absolute;
  top:1em;
  left:1em;
  border-radius: 50%;
  content:'';
  background: var(--color-orange);
  transition-duration: 0.2s;
  opacity: 0;
}

.radio {
  width: calc(50% - 10px);
}

.radio input {
  position: absolute;
  z-index: -9999;
}

.radio input:checked + label {
  background: #fff;
  box-shadow: 0px 0.25em 1.125em #DEE6EA98;
}

.radio input:checked + label:before {
  border-color: var(--color-orange);
}

.radio input:checked + label:after {
  opacity:1;
}

.numbering {
  background: var(--color-orange);
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/SummaryEU.vue